import React, { useState } from 'react';
import { Modal, Button, Typography } from 'antd';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import './ApprovedModal.scss';
import RadioFieldInput from '../../CustomComponents/RadioField/RadioFieldInput';

const { Text } = Typography;

const ApprovedModal = ({
  approvedModalVisible,
  setApprovedModalVisible,
  initiateReturnModalVisible,
  setInitiateReturnModalVisible,
  issueResolutionModalVisible,
  setIssueResolutionModalVisible,
}) => {
  const options = [
    { id: '1', name: 'Initiate Return' },
    { id: '2', name: 'No pickup required' },
  ];
  const handleSubmit = (values) => {
    if (values.returnOption === '1') {
      setInitiateReturnModalVisible(true);
    } else {
      setIssueResolutionModalVisible(true);
    }
    setApprovedModalVisible(!approvedModalVisible);
  };

  return (
    <Formik
      initialValues={{ returnOption: '' }}
      validationSchema={Yup.object({
        returnOption: Yup.string().required('Please select an option'),
      })}
      onSubmit={handleSubmit}>
      {({ setFieldValue, values, errors, touched }) => (
        <Modal
          title={
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Resolve Customer Issue</span>
          }
          open={approvedModalVisible}
          onCancel={() => setApprovedModalVisible(!approvedModalVisible)}
          footer={null}
          centered
          className="return-modal"
          bodyStyle={{
            height: '200px',
          }}>
          <Text className="modal-text">Please select the resolution type:</Text>
          <Form>
            <div className="radio-group">
              <RadioFieldInput
                name="resolutionType"
                label=""
                isRequired
                options={options}
                onSelect={(value) => setFieldValue('returnOption', value)}
                isMultipleAllowed={false}
              />
            </div>

            {touched.returnOption && errors.returnOption && (
              <div className="error-message">{errors.returnOption}</div>
            )}

            <div className="modal-footer">
              <button
                type="button"
                className="close-btn"
                onClick={() => setApprovedModalVisible(false)}>
                Close
              </button>
              <button type="submit" className="submit-btn" disabled={!values.returnOption}>
                Submit
              </button>
            </div>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

export default ApprovedModal;
